import React, { useEffect, useState } from 'react';

export const useAutoScrollToId = (headerHeight) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    const { hash } = window.location;
    if (hash !== '' && mounted) {
      const id = hash.replace('#', '');
      const element = document.getElementById(id);
      window.history.scrollRestoration = 'manual';

      if (element) {
        const currentScrollPosition = window.pageYOffset;
        const elementsDistanceToTopOfViewPort = element.getBoundingClientRect().top;

        const yValue = elementsDistanceToTopOfViewPort + currentScrollPosition - headerHeight;
        window.scrollTo({ top: yValue, behavior: 'smooth' });
      }
    }
  }, [mounted])
};
